import React from "react";

export default class Date extends React.Component<any, any> {
  render() {
    const { field, form, ...props } = this.props;
    return <input id={field.name} {...field} {...props} type="date" />;
  }
}
